@if (errorMessage(); as msg) {
<div
  class="chat-error-banner__body d-flex align-items-start gap-3 p-3 mx-3 mb-2"
  role="alert"
  aria-live="assertive">
  <mat-icon class="chat-error-banner__icon mat-text-error flex-shrink-0">error_outline</mat-icon>

  <div class="d-flex flex-column gap-1 flex-fill">
    <span class="mat-font-label-lg mat-text-error">Something went wrong</span>
    <p class="mat-font-body-sm mb-0 mat-text-on-error-container">{{ msg }}</p>
    <div class="d-flex align-items-center gap-2 mt-2">
      <button matButton (click)="retry.emit()" aria-label="Retry">
        <mat-icon>refresh</mat-icon>
        Retry
      </button>
      <button matButton (click)="dismiss.emit()" aria-label="Dismiss error">
        <mat-icon>close</mat-icon>
        Dismiss
      </button>
    </div>
  </div>
</div>
}
